// CompanyProfileSkeleton.js
import React from "react";
import { Skeleton } from "@heroui/skeleton";
import CompanyHeaderSkeleton from "./HeaderSkeleton";
import NewsGridSkeleton from "./NewsGridSkeleton";
import CompanyOverviewSkeleton from "./OverviewSkeleton";
import TradingViewWidgetSkeleton from "./TradingViewSkeleton";
import BoxSkeleton from "./BoxSkeleton";
import StockOwnershipSkeleton from "./StockOwnershipSkeleton";
import BoxReportSkeleton from "./BoxReportSkeleton";
import BoxSkeletonFinancials from "./BoxSkeletonFinancials";
import SidebarSkeleton from "./SidebarSkeleton";
import BreadcrumbsSkeleton from "./BreadcrumbsSkeleton";
import ChartFairValueSkeleton from "./StockValuationSkeleton";
import StockValuationSkeleton from "./StockValuationSkeleton";

export default function CompanyProfileSkeleton() {
  return (
    <div className="company-profile-page w-full md:p-2 xl:p-2 xl:container min-h-screen mx-auto">
      {/* Sidebar Skeleton for Mobile */}
      <div className="md:hidden mt-5">
        <SidebarSkeleton />
      </div>
      {/* Breadcrumbs Skeleton */}
      <div className="hidden md:block w-full mt-5 mb-5 px-2">
        <BreadcrumbsSkeleton />
      </div>
      {/* Company Header Skeleton */}

      <CompanyHeaderSkeleton />
      <div className="side-navbar flex flex-col md:flex-row mt-4">
        {/* Sidebar Skeleton for Desktop */}
        <div className="hidden md:block md:w-1/4">
          <SidebarSkeleton />
        </div>
        {/* Main Content Skeleton */}
        <div className="company-overview flex-1 md:pl-4">
          <CompanyOverviewSkeleton />
          <TradingViewWidgetSkeleton />
          <BoxReportSkeleton />
          {/*<StockValuationSkeleton /> */}

          <NewsGridSkeleton />
          <BoxSkeletonFinancials />
          <BoxSkeleton />
          <StockOwnershipSkeleton />
        </div>
      </div>
    </div>
  );
}
